import { Axiom } from '@axiomhq/js'

// Initialize Axiom client for browser-side logging
const axiom = new Axiom({
  token: import.meta.env.VITE_AXIOM_TOKEN || '',
  orgId: import.meta.env.VITE_AXIOM_ORG_ID || '',
})

const dataset = import.meta.env.VITE_AXIOM_DATASET || 'talktoast-web-production'

// Helper function to log events
export const logEvent = (level: 'info' | 'warn' | 'error', message: string, data?: Record<string, any>) => {
  if (!import.meta.env.VITE_AXIOM_TOKEN) {
    // Fallback to console if Axiom not configured
    console[level](message, data)
    return
  }

  axiom.ingest(dataset, [{
    _time: new Date().toISOString(),
    level,
    message,
    ...data,
    // Add useful browser context
    userAgent: navigator.userAgent,
    url: window.location.href,
    environment: import.meta.env.MODE,
  }])
}

// Convenience methods
export const logger = {
  info: (message: string, data?: Record<string, any>) => logEvent('info', message, data),
  warn: (message: string, data?: Record<string, any>) => logEvent('warn', message, data),
  error: (message: string, data?: Record<string, any>) => logEvent('error', message, data),

  // Flush logs to Axiom (call this before page unload)
  flush: async () => {
    if (import.meta.env.VITE_AXIOM_TOKEN) {
      await axiom.flush()
    }
  }
}

// Auto-flush on page unload
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    logger.flush()
  })
}

export default logger
